import React from 'react';
import '../assets/styles/Playercard.css'; // import CSS file



const PlayerCard = ({ name, imageUrl, goals }) => {
    return (
    <div className="body">
      <div className="player-card">
        <div className="player-image" style={{backgroundImage: `url(${imageUrl})`}}></div>
        <div className="player-info">
          <h2 className="player-name">{name}</h2>
          <p className="player-goals">{goals} goals</p>
        </div>
      </div>
      </div>
    );
  };
  
  export default PlayerCard;
